import React, { Component, Fragment } from 'react';
import { Status, Types } from '~/Api/DataSourceStatus';
import { formatHumanDate } from '~/DateTime';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';

import styles from './styles.less';

interface Props {
	status: Status;
}

export default class Detail extends Component<Props> {
	render() {
		const { status } = this.props;

		return (
			<div className={styles.item}>
				<div className={styles.detail}>
					{this.renderStatus()}
					<p className={styles.dataSourceName}>
						<span className={styles.dataSourceCountryIcon}>
							<CountryIcon code={status.dataSource.country.alpha2} name={status.dataSource.country.name} />
						</span>
						{status.dataSource.country.name}
						{' - '}
						{status.dataSource.shortName}
					</p>
					<p className={styles.dataSourceDescription}>{status.dataSource.description}</p>
				</div>
				<div className={styles.datasetDetail}>
					<p className={styles.datasetDetailContent}>{this.renderDate()}</p>
				</div>
			</div>
		);
	}

	renderStatus() {
		const { status } = this.props;

		switch (status.type) {
			case Types.upToDate:
				return <p className={styles.upToDateBadge}>UP TO DATE</p>;
			case Types.processing:
				return <p className={styles.processingBadge}>PROCESSING</p>;
			case Types.caution:
				return <p className={styles.reconstructionBadge}>RECONSTRUCTION</p>;
			default:
				return null;
		}
	}

	renderDate() {
		const { status } = this.props;

		return (
			<Fragment>
				Last update date:
				<br />
				<strong className={styles.datasetDetailDate}>{formatHumanDate(status.lastUpdateAt)}</strong>
			</Fragment>
		);
	}
}
